module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ideas-and-suggestions":"Ideas and development suggestions"},"fi":{"ideas-and-suggestions":"Ideat ja toimenpide-ehdotukset"},"sv":{"ideas-and-suggestions":"Idéer och förslag"},"de":{"ideas-and-suggestions":"Ideen und Vorschläge"},"ko":{"ideas-and-suggestions":"아이디어 및 제안"}}')
  delete Component.options._Ctor
}
